export default __webpack_public_path__ + "static/media/ic-subscriptions.7d78acb6.svg";